import { Box, Col, Container, Row } from '@dbi-tools/ui-kit';
import imgLogo from '@quiz-frontend/markup/images/logo-main.svg';
import imgPearlLogo from '@quiz-frontend/markup/images/logo-pearl.svg';
import { DAVIDS_URL, PEARL_URL } from '@quiz-frontend/quiz-builder/service/variables';
import React, { ReactNode } from 'react';

import { APP_NAME } from '../types/app';
import { HeaderStyled, LogoImg, LogoLink } from './header.styled';

type HeaderProps = {
  leftSlot?: ReactNode;
  rightSlot?: ReactNode;
  appName: APP_NAME;
};

const Header: React.FC<HeaderProps> = ({ leftSlot, rightSlot, appName }) => {
  const isVisionBoard = appName === APP_NAME.VisionBoard;

  const logoHref = isVisionBoard ? PEARL_URL : DAVIDS_URL;
  const logoSrc = isVisionBoard ? imgPearlLogo.src : imgLogo.src;

  return (
    <HeaderStyled>
      <Container>
        <Row justifyContent="between" alignItems="center">
          <Col col={4}>{leftSlot && <Box align="left">{leftSlot}</Box>}</Col>
          <Col col={4}>
            <LogoLink href={logoHref} target={logoHref ? '_blank' : null}>
              <LogoImg src={logoSrc} alt="logo" />
            </LogoLink>
          </Col>
          <Col col={4}>{rightSlot && <Box align="right">{rightSlot}</Box>}</Col>
        </Row>
      </Container>
    </HeaderStyled>
  );
};

export default Header;
